import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import FTLTypography from "./FTLTypography";
import { FTLLogoIcon } from "../icons";
export default ({ title, logo = React.createElement(FTLLogoIcon, { sizeRatio: 0.6 }), logoLink = "/", children, }) => {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement(Link, { to: logoLink, className: classes.link },
                logo,
                React.createElement(Box, { ml: 4 },
                    React.createElement(FTLTypography, { variant: "h2" }, title)))),
        React.createElement(Box, { ml: "auto" }, children)));
};
const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: theme.zIndex.appBar,
        position: "relative",
        display: "flex",
        alignItems: "center",
        padding: "9.5px 28px 9.5px 24px",
        maxHeight: 56,
        borderBottom: "1px solid #EBEDF0",
        backgroundColor: "#fff",
        [theme.breakpoints.down("sm")]: { padding: "9.5px 10px 9.5px 16px" },
    },
    logo: {
        width: "24px",
        height: "24px",
    },
    divider: {
        margin: "8px 0",
    },
    link: {
        display: "flex",
        textDecoration: "none",
    },
    listContainer: {
        minWidth: 192,
        padding: 0,
        marginTop: 4,
    },
    listItem: {
        padding: "6px 12px",
    },
    listItemText: {
        margin: "0",
        "& > span": Object.assign({}, theme.typography.listItemText),
    },
}));
//# sourceMappingURL=FTLHeader.js.map